import api from './client';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  success: boolean;
  username: string;
  email: string;
  org_id?: string;
  org_name?: string;
  is_admin: boolean;
  token: string;
}

export interface UserInfo {
  username: string;
  email: string;
  org_id?: string;
  org_name?: string;
  is_admin: boolean;
}

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await api.post('/v1/auth/login', credentials);
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.post('/v1/auth/logout');
  },

  getCurrentUser: async (): Promise<UserInfo> => {
    const response = await api.get('/v1/auth/me');
    return response.data;
  }
};
